import React, { Children, FC, ReactElement, ReactNode } from 'react'

import styles from './styles.module.css'

interface RowProps {
  children: ReactNode
}

const Row: FC<RowProps> = ({ children }) => <div className={styles.row}>{children}</div>

interface TitleLargeProps {
  children: ReactNode
}

const TitleLarge: FC<TitleLargeProps> = ({ children }) => <span className={styles.titleLarge}>{children}</span>

interface TitleMediumProps {
  children: ReactNode
}

const TitleMedium: FC<TitleMediumProps> = ({ children }) => <span className={styles.titleMedium}>{children}</span>

interface TitleProps {
  children: ReactNode
}

const Title: FC<TitleProps> = ({ children }) => <span className={styles.title}>{children}</span>

interface TitleSmallProps {
  children: ReactNode
}

const TitleSmall: FC<TitleSmallProps> = ({ children }) => <span className={styles.titleSmall}>{children}</span>

interface FooterProps {
  children: string
}

const Footer: FC<FooterProps> = ({ children }) => <div className={styles.footer}>{children}</div>

interface DetailBoxProps {
  isMobileView?: boolean
  children: ReactNode
  schema?: { itemProp: string; itemScope: boolean; itemType: string } | Record<string, unknown>
}

const DetailBox = ({ isMobileView, children, schema = {} }: DetailBoxProps) => {
  const childrenArray = Children.toArray(children) as ReactElement[]
  const hasFooter = childrenArray[childrenArray.length - 1].type === Footer

  return (
    <div className={styles.box} data-has-footer={hasFooter} data-is-mobile-view={isMobileView} {...schema}>
      {children}
    </div>
  )
}

DetailBox.Row = Row
DetailBox.TitleLarge = TitleLarge
DetailBox.TitleMedium = TitleMedium
DetailBox.Title = Title
DetailBox.TitleSmall = TitleSmall
DetailBox.Footer = Footer

export default DetailBox
